import { render } from "./FishList.vue?vue&type=template&id=5018b142&scoped=true&ts=true"
import script from "./FishList.vue?vue&type=script&lang=ts"
export * from "./FishList.vue?vue&type=script&lang=ts"

import "./FishList.vue?vue&type=style&index=0&id=5018b142&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/olaria-client/olaria-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5018b142"]])

export default __exports__